import React, { Component } from 'react';
import { css } from 'aphrodite';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import moment from 'moment';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import { Button } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ApiHelper } from '../../common/helpers/ApiHelper';
import { Helper } from '../../common/helpers/Helper';
import { Controller } from '../../common/Controller';
import { UiHelper } from '../../common/helpers/UiHelper';
import { AppHelper } from '../../helpers/AppHelper.js';
import { SearchHelper } from '../../helpers/SearchHelper';
import { ParkingHelper } from '../../helpers/ParkingHelper'
import { Styles } from './Styles';
import { EventActionHeaderbar } from './EventActionHeaderBar';
import { EventList } from './EventList';
import { EventStats } from './EventStats';
import { EventDetails } from './EventDetails';
import { EventEditor } from './EventEditor';
import { adminData } from '../../data/AdminData.js'
import { AppConfig } from '../../AppConfig';
import { CommonStyles } from '../../styles/Styles';

const queryString = require('query-string');

export class ClientPlacesDetails extends Component {
  constructor(props) {
    super(props);
    this.queryParams = (props.location && props.location.search) ? queryString.parse(props.location.search) : null
    this.eventUpdateIntervalFnId = null;
    this.placeId = this.props.match.params.id ? this.props.match.params.id : null;
    this.eventsByGroupId = {}
    this.fromDateTs = null
    this.toDateTs = null
    this.selectedCamIds = this.getSelectedCamIds()
    this.liveUrl = null
    this.tagFilters = []
    this.priorityFilters = []
    this.tagValue = {}
    this.parkingEntry = { IN: 0, OUT: 0, PARKED: 0 },
    this.parkingEntryTotal = { IN_TOTAL: 0, OUT_TOTAL: 0 },
    this.state = {
      fetchState: ApiHelper.State.LOADING,
      pageNumber: 0,
      selectedEvent: null,
      selectedRelatedEvent: null,
      paginate: false,
      statAdjust: 0,
      parkedVal: 0,
      eventIndex: 0,
      eventLatest: null,
      eventEditor: false,
      eventListLoading: false,
      eventList: [],
      eventCompleteList: [],
      relativeImageSliderMode: false,
    }
  }

  componentDidMount() {
    this.fetchItems();
  }

  componentWillUnmount() {
    if (this.eventUpdateIntervalFnId) {
      clearInterval(this.eventUpdateIntervalFnId);
    }
  }

  fetchItems = () => {
    ApiHelper.call(
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['places', this.placeId]) },
      function (err, result) {
        if (err) {
          this.setState({
            fetchState: ApiHelper.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }

        const statAdjust = result.statAdjust ? result.statAdjust : 0

        this.setBreadcrumbs(result)

        if (result && result.cams.length > 0) {
          this.streamContentHeight = result.cams[0].streamContentHeight
          this.streamContentWidth = result.cams[0].streamContentWidth
          if (!this.selectedCamIds || this.selectedCamIds.length === 0) {
            this.selectedCamIds = [result.cams[0]._id]
            this.liveUrl = result.cams[0].urlJpeg
          } else {
            for (const cam of result.cams) {
              if (this.selectedCamIds[0] === cam._id) {
                this.liveUrl = cam.urlJpeg
                break
              }
            }
          }

          this.setState({
            place: result,
            statAdjust: statAdjust
          }, () => this.updateEvents())
        } else {
          this.setState({
            fetchState: ApiHelper.State.ERROR,
            errMsg: Helper.getString('camNotFound')
          })
        }

      }.bind(this))
  }

  setBreadcrumbs = (item) => {
    this.breadcrumbs = [
      {
        title: 'Places',
        to: '/orgs/' + item.orgId + '/places'
      },
      {
        title: 'Live Grid',
        to: '/places/' + item._id + '/cams'
      },
      {
        title: 'Events',
        to: ''
      },
    ]
  }

  getSelectedCamIds = () => {
    if (!this.queryParams || !this.queryParams.camId) {
      return []
    }

    const valueStr = this.queryParams.camId
    if (valueStr) {
      return valueStr.split(',')
    } else {
      return []
    }
  }

  updateEvents = (action) => {
    const params = {
      priority: AppHelper.getGlobalPriotiyValue(),
      limit: AppConfig.eventQueryLimit,
    }

    if (this.fromDateTs && this.toDateTs) {
      params.fromDateTs = this.fromDateTs
      params.toDateTs = this.toDateTs
    }

    params.camId = this.selectedCamIds
    params.pageNumber = this.state.pageNumber

    if (action === 'next') {
      this.setState({
        eventList: [],
        eventListLoading: true
      })

      if (!this.state.paginate) {
        return
      }

      params.pageNumber = this.state.pageNumber + 1
    }

    if (action === 'prev') {
      this.setState({
        eventList: [],
        eventListLoading: true
      })

      if (this.state.pageNumber === 0) {
        return
      }

      params.pageNumber = this.state.pageNumber - 1
    }

    const options = {
      method: 'GET',
      endPoint: ApiHelper.makeUrlPath(['places', this.placeId, 'events'], params)
    }

    ApiHelper.call(
      options,
      function (err, result) {
        if (err) {
          this.setState({
            fetchState: ApiHelper.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }

        const modifiedEventList = this.processEvents(result.items)

        const currSelectedEvent = this.getCurrSelectedEvent(modifiedEventList)

        this.updateUrl()

        let eventLatest = this.state.eventLatest
        if (this.state.pageNumber === 0) {
          eventLatest = (result.items.length > 0) ? result.items[0] : null
        }

        if (this.state.place &&
          this.state.place.type === 'parking_in_out' &&
          this.state.pageNumber === 0) {
          const parkingStats = ParkingHelper.processParkingStats(this.parkingEntry, this.parkingEntryTotal,  this.state.statAdjust, result.items)
          this.parkingEntry = parkingStats.parkingEntry
          this.parkingEntryTotal = parkingStats.parkingEntryTotal
        }

        this.setState({
          pageNumber: result.currPageNumber,
          paginate: result.more ? true : false,
          eventList: modifiedEventList,
          eventLatest: eventLatest,
          selectedEvent: currSelectedEvent.event,
          selectedRelatedEvent: currSelectedEvent.relatedEvent,
          eventIndex: currSelectedEvent.eventIndex,
          fetchState: ApiHelper.State.READY,
          eventCompleteList: result.items,
          eventListLoading: false
        })

      }.bind(this))
  }

  getCurrSelectedEvent = (modifiedEventList) => {
    if (!this.state.selectedEvent) {
      return {
        event: modifiedEventList.length > 0 ? modifiedEventList[0] : null,
        eventIndex: 0,
        relatedEvent: null
      }
    }

    let index = 0
    for (const item of modifiedEventList) {
      if (item._id === this.state.selectedEvent._id) {
        if (item.groupId && this.state.selectedRelatedEvent) {
          for (const rItem of this.eventsByGroupId[item.groupId]) {
            if (rItem._id === this.state.selectedRelatedEvent._id) {
              return {
                event: item,
                eventIndex: index,
                relatedEvent: rItem
              }
            }
          }
        } else {
          return {
            event: item,
            eventIndex: index,
            relatedEvent: null,
          }
        }
      }
      index = index + 1
    }

    return {
      event: modifiedEventList.length > 0 ? modifiedEventList[0] : null,
      eventIndex: 0,
      relatedEvent: null,
    }
  }

  updateUrl = () => {
    let camIdStr = ''
    for (const id of this.selectedCamIds) {
      if (camIdStr) {
        camIdStr = camIdStr + ',' + id
      } else {
        camIdStr = id
      }
    }
    this.props.history.replace('/places/' + this.placeId + '?camId=' + camIdStr)
  }

  processEvents = (items) => {
    items = this.filterWithParams(items)
    this.eventsByGroupId = {}
    const modifiedEventList = []
    for (const item of items) {
      if (!item.groupId) {
        modifiedEventList.push(item)
        continue
      }

      if (this.eventsByGroupId[item.groupId] === undefined) {
        modifiedEventList.push(item)
        this.eventsByGroupId[item.groupId] = []
      } else {
        this.eventsByGroupId[item.groupId].push(item)
      }
    }
    return modifiedEventList
  }

  timeChangeHandler = (fromDateTs, toDateTs) => {
    this.fromDateTs = fromDateTs
    this.toDateTs = toDateTs
    this.setState({
      pageNumber: 0
    }, () => this.updateEvents())
  }

  camSelectHandler = (camIds) => {
    this.selectedCamIds = camIds
    this.updateUrl()
    this.updateEvents()
    this.setState({
      pageNumber: 0
    }, () => this.updateEvents())
  }

  filterHandler = (tagFilters, priorityFilters, tagValue) => {
    this.tagFilters = tagFilters
    this.priorityFilters = priorityFilters
    this.tagValue = tagValue
    const filteredItems = this.filterWithParams(this.state.eventCompleteList)
    const modifiedEventList = this.processEvents(filteredItems)
    const currSelectedEvent = this.getCurrSelectedEvent(modifiedEventList)
    this.setState({
      eventList: modifiedEventList,
      selectedEvent: currSelectedEvent.event,
      selectedRelatedEvent: currSelectedEvent.relatedEvent,
      eventIndex: currSelectedEvent.eventIndex,
    })
  }

  eventRefreshHandler = (refresh) => {
    if (refresh) {
      this.startAutoUpdate()
    } else {
      this.stopAutoUpdate()
    }
  }

  searchHandler = (searchText) => {
    this.searchText = searchText
    const filteredItems = this.filterWithParams(this.state.eventCompleteList)
    const modifiedEventList = this.processEvents(filteredItems)
    const currSelectedEvent = this.getCurrSelectedEvent(modifiedEventList)
    this.setState({
      eventList: modifiedEventList,
      selectedEvent: currSelectedEvent.event,
      selectedRelatedEvent: currSelectedEvent.relatedEvent,
      eventIndex: currSelectedEvent.eventIndex,
    })
  }

  filterWithParams = (items) => {
    let eventListAfterFilter = []
    if (this.searchText) {
      eventListAfterFilter = SearchHelper.filterItemsBySearchText(this.searchText, items)
    } else {
      eventListAfterFilter = items
    }

    if (this.tagFilters && this.tagFilters.length > 0) {
      eventListAfterFilter = SearchHelper.filterItemsByTag(this.tagFilters, this.tagValue, eventListAfterFilter)
    }

    if (this.priorityFilters && this.priorityFilters.length > 0) {
      eventListAfterFilter = SearchHelper.filterItemsByPriority(this.priorityFilters, eventListAfterFilter)
    }
    return eventListAfterFilter
  }

  onEventTileSelect = (item, index) => {
    this.setState({
      selectedEvent: item,
      eventIndex: index,
      selectedRelatedImage: 0,
      selectedRelatedEvent: null,
    })
  }

  onRelatedEventTileClick = (item) => {
    this.setState({
      selectedRelatedEvent: item
    })
  }

  startAutoUpdate = () => {
    this.eventUpdateIntervalFnId = setInterval(() => {
      if (this.state.pageNumber === 0) this.updateEvents();
    }, AppConfig.eventRefreshInterval);
  }

  stopAutoUpdate = () => {
    if (this.eventUpdateIntervalFnId) {
      clearInterval(this.eventUpdateIntervalFnId);
      this.setState({
        restoreUpdate: true
      })
    }
  }

  enableAutoUpdate = () => {
    if (this.state.restoreUpdate) {
      this.eventUpdateIntervalFnId = setInterval(() => {
        if (this.state.pageNumber === 0) this.updateEvents();
      }, AppConfig.eventRefreshInterval);
      this.setState({
        restoreUpdate: false
      })
    }
  }

  closeEventEditor = () => {
    this.setState({
      eventEditor: false,
      selectedEditItem: {}
    })
    this.enableAutoUpdate()
  }

  showEventEditor = (item) => {
    let prioritySelected
    for (const p of adminData.priorityValues) {
      if (item.priority === p.value) {
        prioritySelected = p
      }
    }
    this.setState({
      eventEditor: true,
      selectedEditItem: item,
      prioritySelected: prioritySelected
    })
    this.stopAutoUpdate();
  }

  editEvent = (priority, mode) => {
    let options = {}
    if (mode === 'save') {
      options = {
        method: 'POST',
        endPoint: ApiHelper.makeUrlPath(['events', this.state.selectedEditItem._id]),
        jsonBody: {
          priority: Number(priority)
        }
      }
    } else if (mode === 'delete') {
      options = {
        method: 'DELETE',
        endPoint: ApiHelper.makeUrlPath(['events', this.state.selectedEditItem._id]),
      }
    } else {
      return
    }

    ApiHelper.call(options, function (err, data) {
      if (err) {
        const msg = err.message ? err.message : Helper.getString('defaultErrorMsg')
        this.setState({
          errMsg: msg,
          errCode: err.respCode,
        })
        return
      }
      this.setState({
        eventEditor: false,
      })
      this.updateEvents()
    }.bind(this))
  };

  downloadReport = () => {
    Controller.get().pushRouteWithParams('/reports/' + this.placeId,
      {
        selectedCamIds: this.selectedCamIds,
        priorityFilters: this.priorityFilters,
        tagFilters: this.tagFilters,
        tagValue: this.tagValue,
        fromDateTs: this.fromDateTs,
        toDateTs: this.toDateTs
      })
  }

  imageSliderHandler = (sliderMode) => {
    this.setState({
      relativeImageSliderMode: sliderMode
    })
  }

  openStatDialog = () => {
    this.setState({
      parkedVal: this.parkingEntry.PARKED,
      statDialog: true,
    })
  }

  closeStatDialog = () => {
    this.setState({
      statDialog: false,
    })
  }

  statUpdateHandler = (newVal) => {
    this.parkingEntry.PARKED = this.parkingEntryTotal.IN_TOTAL - this.parkingEntryTotal.OUT_TOTAL + newVal
    this.setState({
      statAdjust: newVal
    })
  }

  parkedValChangeHandler = (newVal) => {
    this.setState({
      parkedVal: newVal
    })
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return UiHelper.errorView(this);
    } else {
      return this.readyView();
    }
  }

  readyView() {
    return (
      <div className={css(CommonStyles.outerMainContainer)}>
        <EventActionHeaderbar
          title={this.state.place.name}
          breadcrumbs={this.breadcrumbs}
          timeChangeHandler={this.timeChangeHandler}
          camSelectHandler={this.camSelectHandler}
          filterHandler={this.filterHandler}
          eventRefreshHandler={this.eventRefreshHandler}
          place={this.state.place}
          relativeImageSliderMode={this.state.relativeImageSliderMode}
          selectedCamIds={this.selectedCamIds}
        />

        {(!this.state.eventCompleteList || this.state.eventCompleteList.length === 0) &&
          <p className={css(Styles.emptyEventContainer)}>{Helper.getString('noEventsFound')}</p>
        }

        {this.state.eventCompleteList &&
          this.state.eventCompleteList.length > 0 &&
          <div>
            <EventStats
              eventLatest={this.state.eventLatest}
              place={this.state.place}
              parkingEntryTotal={this.parkingEntryTotal}
              parkingEntry={this.parkingEntry}
              openStatDialog={this.openStatDialog}
              closeStatDialog={this.closeStatDialog}
              statDialog={this.state.statDialog}
              statAdjust={this.state.statAdjust}
              parkedVal={this.state.parkedVal}
              eventCompleteList={this.state.eventCompleteList}
              pageNumber={this.state.pageNumber}
              statUpdateHandler={this.statUpdateHandler}
              parkedValChangeHandler={this.parkedValChangeHandler}
            />

            <div className={css(CommonStyles.innerMainContainer)}>
              <div className={css(Styles.innerContainer)}>
                <EventList
                  eventsByGroupId={this.eventsByGroupId}
                  onEventTileSelect={this.onEventTileSelect}
                  searchHandler={this.searchHandler}
                  paginate={this.state.paginate}
                  pageNumber={this.state.pageNumber}
                  updateEvents={this.updateEvents}
                  eventList={this.state.eventList}
                  relativeImageSliderMode={this.state.relativeImageSliderMode}
                  eventListLoading={this.state.eventListLoading}
                />

                <EventDetails
                  liveUrl={this.liveUrl}
                  placeId={this.placeId}
                  camId={(this.selectedCamIds && this.selectedCamIds.length > 0) ? this.selectedCamIds[0] : null}
                  streamContentHeight={this.streamContentHeight}
                  streamContentWidth={this.streamContentWidth}
                  searchHandler={this.searchHandler}
                  eventsByGroupId={this.eventsByGroupId}
                  eventList={this.state.eventList}
                  onEventTileSelect={this.onEventTileSelect}
                  onRelatedEventTileClick={this.onRelatedEventTileClick}
                  imageSliderHandler={this.imageSliderHandler}
                  selectedEvent={this.state.selectedEvent}
                  eventList={this.state.eventList}
                  selectedRelatedEvent={this.state.selectedRelatedEvent}
                  relativeImageSliderMode={this.state.relativeImageSliderMode}
                  eventIndex={this.state.eventIndex}
                  showEventEditor={this.showEventEditor}
                  downloadReport={this.downloadReport}
                />
              </div>
            </div>
          </div>
        }

        {this.state.eventEditor &&
          <EventEditor
            eventEditor={this.state.eventEditor}
            closeEventEditor={this.closeEventEditor}
            selectedEditItem={this.state.selectedEditItem}
            editEvent={this.editEvent}
            prioritySelected={this.state.prioritySelected}
          />
        }

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/ClientPlace/ClientPlacesDetails.js